import api from "../../api/apiSkills";

let initialState = {
    data:null
}

const ACTION_GET_SKILLS = "page/skills/get";

export default function  SkillsReducer (state = initialState, action){
    switch (action.type) {
        case ACTION_GET_SKILLS: {
            return {
                data: action.data
            };
        };
        default: return state;
    }
}
const ActionSkills = (data) => ({
    type: ACTION_GET_SKILLS,
    data: data
});

export function ThunkCretorGetSkills() {
    return (dispatch) => {
        api.get().then((response) => {
            if (response.status == 200) {
                let result = response.data;
                dispatch(ActionSkills(result.value));
            }
        });
    }
}